import React from 'react';
import { Grid, CircularProgress } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DyamicDropdown';
import { useFilters } from '../FilterContext';
import { useServices } from './hooks/useServices';
import { useFilterInitialization } from './hooks/useFilterInitialization';

export const ServiceFilter = () => {
  const { filterValues, updateFilter } = useFilters();
  const { siteAppID, customCaptions } = JSON.parse(localStorage.getItem("me")) || 
    JSON.parse(sessionStorage.getItem("me"));
    
  // Extract values from other filters
  const departmentFilter = filterValues.department;
  const timeframeFilter = filterValues.timeframe;
  const departmentId = departmentFilter?.value?.id;

  const {
    services,
    isLoading,
    searchQuery,
    handleSearchChange,
    handleDropdownClick
  } = useServices(
    siteAppID,
    departmentFilter,
    timeframeFilter,
    updateFilter,
    filterValues
  );

  // Use useFilterInitialization for dependency management (reset when department changes)
  useFilterInitialization('service', [{}], {
    getDefaultValue: () => ({}),
    getParams: (service) => ({ serviceId: service.id || '' }),
    dependencies: [departmentId],
    resetOnDependencyChange: true, // Reset service when department changes
    waitForData: false // Don't wait for data since this is server-side
  });

  // Handle service selection
  const handleServiceChange = (service) => {
    if (!service || !service.id) {
      updateFilter('service', {}, { serviceId: '' });
      return;
    }
    
    // Create a display value that includes all the required service details
    const serviceDisplayInfo = {
      ...service,
      displayDetails: `${service.modelName || ''} ${service.model || ''} - ${service.siteAssetName || ''} - ${service.interval || ''} - ${service.role || ''}`
    };
    
    updateFilter(
      'service',
      serviceDisplayInfo,
      { serviceId: service.id }
    );
  };

  return (
    <Grid item lg={3} md={6} xs={12} sx={{ position: 'relative' }}>
      {isLoading && (
        <CircularProgress 
          size={20} 
          sx={{
            position: 'absolute',
            right: '40px',
            top: '32px',
            zIndex: 1
          }}
        />
      )}
      <DyanamicDropdown
        width="100%"
        dataSource={services}
        dataHeader={[
          { id: 1, name: customCaptions?.workOrder || 'Work Order' },
          { id: 3, name: customCaptions?.department || 'Department' }
        ]}
        showHeader
        columns={[
          { id: 1, name: 'workOrder', minWidth: '130px' },
          { id: 3, name: 'departmentName', minWidth: '150px' }
        ]}
        columnsMinWidths={[140, 140, 150]}
        placeholder={`Search for a ${customCaptions?.workOrder || 'Work Order'}`}
        onChange={handleServiceChange}
        selectdValueToshow="workOrder"
        selectedValue={filterValues.service?.value || {}}
        label={`Filter by ${customCaptions?.workOrder || 'Work Order'}`}
        icon={<FilterListIcon style={{ color: 'rgb(48, 122, 215)' }} />}
        required={true}
        showBorderColor
        isServerSide={true}
        handleServerSideSearch={handleSearchChange}
        PreloadedSearch={searchQuery}
        dropDownActiveWidth="500px"
        fetchData={handleDropdownClick}
      />
    </Grid>
  );
};
